<template>
	<div id="company-container" class="card pb-3">
		<b-modal v-model="showAddModal" v-if="showAddModal" @ok="addJob" :ok-disabled="!jobName">
			<template #modal-title><h5>Add New Job</h5></template>
			<div class="row">
				<label class="col">Job Name <input class="form-control " v-model="jobName"/></label>
			</div>
		</b-modal>
		<vue-headful
				:title="title">
		</vue-headful>
		<div class="card-body">
			<div class="card-title">
				<div class="row">
					<h5 class="col-6"><strong>Company {{ record.fieldData['Company_PK_ID'] }}</strong></h5>
					<h5 class="col-6">
						<span class="float-right"><strong>{{ record.fieldData['Company Name'] }}</strong></span>
					</h5>
				</div>
			</div>
			<div class="row">
				<div class="col-6">
					<div class="card">
						<div class="card-header pb-2 pt-2">
							Contact Information
						</div>
						<div class="card-body">
							<div class="detail-field-group">
								<div>
									<label>Address 1</label>
									<div>{{ record.fieldData['Address 1'] }}</div>
								</div>
								<div>
									<label>Address 2</label>
									<div>{{ record.fieldData['Address 2'] }}</div>
								</div>
								<!--<div>
                                  <label>Address 3</label>
                                  <div>{{record.fieldData['Address 3']}}</div>
                                </div>-->
								<div style="display: inline-flex; margin-bottom: 0;">
									<div style="padding-right: 1em; margin-bottom: 0;">
										<label>City</label>
										<div>{{ record.fieldData['City'] }}</div>
									</div>
									<div style="padding-right: 1em; margin-bottom: 0;">
										<label>State</label>
										<div>{{ record.fieldData['State'] }}</div>
									</div>
									<div style="margin-bottom: 0;">
										<label>Zip</label>
										<div>{{ record.fieldData['Zip'] }}</div>
									</div>
								</div>
								<!--<div>
                                  <label>County</label>
                                  <div>{{record.fieldData['County']}}</div>
                                </div>-->
								<div>
									<label>Primary Phone</label>
									<div>{{ record.fieldData['Contact Main Telephone'] }}</div>
								</div>
								<div>
									<label>Fax</label>
									<div>{{ record.fieldData['Contact Fax Telephone'] }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-6">
					<div class="row">
						<div class="col-12">
							<div class="card">
								<div class="card-header pb-2 pt-2">Registrations</div>
								<div class="card-body pt-2">
									<b-table
											id="registration-table"
											:fields="regFields"
											:items="record.portalData.Registration | regFilter"
											:per-page="regRowsPerPage"
											:current-page="regPage"
											primary-key="Registration::Record_Number_PK_ID"
											small
											responsive
											hover
									>
										<template v-slot:cell(view)="data" style="width: 28px;">
											<router-link
													:to="{name: 'registration', params: {id: data.item.recordId}}">
												<font-awesome-icon icon="eye"></font-awesome-icon>
											</router-link>
										</template>
										<template v-if="accessPrivileges.includes('CREATE_JOB')" v-slot:cell(add)="data">
											<a href="#"
											   @click="confirmAddJob(data.item['Registration::Record_Number_PK_ID'])"
											   class="company-add">
												<font-awesome-icon icon="plus-circle"></font-awesome-icon>
											</a>
										</template>
									</b-table>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-4">
							<div class="card" style="border: none;">
								<div class="card-body" style="padding-left: 0; padding-right: 0;">
									<h6 class="card-title">Labeler Codes</h6>
									<div>
										<div v-for="code in record.portalData.Labeler_Codes">
											{{ code['Labeler_Codes::Labeler Code'] }}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-8">
							<div class="card" style="border: none;">
								<div class="card-body">
									<h6 class="card-title">Report Type</h6>
									<div class="custom-control custom-checkbox custom-control-inline">
										<input type="checkbox" id="41" value="41" v-model="reportTypes"
											   class="custom-control-input"
											   disabled>
										<label for="41" class="custom-control-label">41</label>
									</div>
									<div class="custom-control custom-checkbox custom-control-inline">
										<input type="checkbox" id="manifest" value="Manifest" v-model="reportTypes"
											   class="custom-control-input" disabled>
										<label for="manifest" class="custom-control-label">Manifest</label>
									</div>
									<div class="custom-control custom-checkbox custom-control-inline">
										<input type="checkbox" id="see-notes" value="See Notes" v-model="reportTypes"
											   class="custom-control-input" disabled>
										<label for="see-notes" class="custom-control-label">See Notes</label>
									</div>
									<div class="custom-control custom-checkbox custom-control-inline">
										<input type="checkbox" id="cod" value="COD" v-model="reportTypes"
											   class="custom-control-input" disabled>
										<label for="cod" class="custom-control-label">COD</label>
									</div>
									<div class="custom-control custom-checkbox custom-control-inline">
										<input type="checkbox" id="ldr" value="LDR" v-model="reportTypes"
											   class="custom-control-input" disabled>
										<label for="ldr" class="custom-control-label">LDR</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row" style="margin-top: 1em;">
				<div class="col-12">
					<!--<PortalGrid
                        :columns="contColumns"
                        :pagination-class="'pagination-sm'"
                        :rows="record.portalData.Contacts_Info"
                        :portal-name="contPortalName"
                        :page="contPage"
                        :has-footer="contFooter"
                        :has-header="contHeader"
                        :header-title="contTitle"
                        :rest-detail-entity="contRestDetailEntity"
                        :has-detail-column="false"
                        :has-add-column="false"
                        :has-search="false"
                        :rows-per-page="10"
                        :max-rows="50"
                    >
                    </PortalGrid>-->

				</div>
			</div>
		</div>
	</div>
</template>

<script>

//Registration::Expiration Date ≥ Get ( CurrentDate ) and Registration::Federal Agency = "Drug Enforcement Administration"

import feedbackMixin from '../mixins/feedback'
import detailViewMixin from '../mixins/detail-view'
import PortalGrid from '../components/PortalGrid'

import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);

Vue.use(VueMoment, {
	moment,
});

export default {
	name: 'Company',
	mixins: [feedbackMixin, detailViewMixin],
	components: {PortalGrid},
	methods: {
		addJob: function () {
			this.showErrMsg = false;
			if (this.selectedRegistration > 0 && this.jobName && this.jobName !== '') {
				Vue.axios.post('/3ds/api/job',
					{
						fieldData: {
							'_fkRegistration_Record_Number': this.selectedRegistration,
							'Job Name': this.jobName
						}
					},
					{
						headers: {
							'Authorization': 'Bearer ' + this.token
						}
					}
				)
					.then(value => {
						console.log('Successfully added a job')
						console.log(JSON.stringify(value))
						this.$router.push({
							name: 'job-view',
							params: {
								id: value.data.recordId
							}
						})
					})
					.catch(reason => {
						console.log('Failed to add a job')
						this.authCheck(reason)
					})
					.finally(() => {
						this.showAddModal = false
					})
			} else {
				this.showErrMsg = true
			}
		},
		confirmAddJob: function (selectedRegistration) {
			this.jobName = '';
			this.showErrMsg = false;
			this.selectedRegistration = selectedRegistration;
			this.showAddModal = true
		}
	},
	created: function () {
		this.record.fieldData['Report Type'] = ''
	},
	computed: {
		reportTypes: function () {
			return this.record.fieldData['Report Type'].split('\r')
		},
		title: function () {
			return this.record.fieldData['Company Name']
		}
	},
	filters: {
		regFilter: function (regArray) {
			if (regArray) {
				return regArray.filter(element => {
					let expDateString = element['Registration::Expiration Date'];
					let agency = element['Registration::Federal Agency'];
					let expDate = moment(expDateString, 'MM/DD/YYYY');
					let now = moment();
					return expDate.isSameOrAfter(now) && agency === 'Drug Enforcement Administration'
				})
			}
		}
	},
	data() {
		return {
			showAddModal: false,
			jobName: '',
			selectedRegistration: 0,
			showErrMsg: false,
			portals: [
				{
					name: 'Contacts_Info',
					limit: 100
				},
				{
					name: 'Registration',
					limit: 100
				},
				{
					name: 'Labeler_Codes',
					limit: 100
				}
			],
			restEntity: 'company',
			regPortalName: 'Registration',
			regTitle: 'Registrations',
			regRestDetailEntity: 'registration',
			regFooter: false,
			regHeader: false,
			regPage: 1,
			regRowsPerPage: 10,
			/*regColumns: [
                {
                    name: 'Registration::Record_Number_PK_ID',
                    displayName: '',
                    hidden: true,
                    pk: true
                },
                {
                    name: 'Registration::Activity',
                    displayName: 'License Type'
                },
                {
                    name: 'Registration::Registration Number',
                    displayName: 'Registration'
                },
                {
                    name: 'Registration::Expiration Date',
                    displayName: 'Expiration'
                },
            ],*/
			regFields: [
				{
					key: 'view',
					label: '',
					thStyle: {
						width: '35px'
					}
				},
				{
					key: 'Registration::Activity',
					label: 'License Type',
					sortable: true
				},
				{
					key: 'Registration::Registration Number',
					label: 'Registration',
					sortable: true
				},
				{
					key: 'Registration::Expiration Date',
					label: 'Expiration',
					sortable: true
				},
				{
					key: 'add',
					label: ''
				},
			],
			contPortalName: 'Contacts_Info',
			contTitle: 'Contacts',
			contRestDetailEntity: 'contact',
			contFooter: false,
			contHeader: false,
			contPage: 1,
			contRowsPerPage: 10,
			/*contColumns: [
                {
                    name: 'Contacts_Info::Contact Last Name',
                    displayName: 'Last Name',
                    sort: 0
                },
                {
                    name: 'Contacts_Info::Contact First Name',
                    displayName: 'First Name',
                    sort: 0
                },
                /!*{
                    name: 'Contacts_Info::Contact Middle Name',
                    displayName: 'Contacts_Info::Contact Middle Name',
                    sort: 0
                },*!/
                {
                    name: 'Contacts_Info::Title',
                    displayName: 'Title',
                    sort: 0
                },
                {
                    name: 'Contacts_Info::City',
                    displayName: 'City',
                    sort: 0
                },
                {
                    name: 'Contacts_Info::Contact Direct Telephone Mask',
                    displayName: 'Phone',
                    sort: 0
                },
                {
                    name: 'Contacts_Info::Contact Direct Telephone Extension',
                    displayName: 'Ext',
                    sort: 0
                }
            ],*/
			contFields: [
				{
					key: 'Contacts_Info::Contact Last Name',
					label: 'Last Name',
					sortable: true
				},
				{
					key: 'Contacts_Info::Contact First Name',
					label: 'First Name',
					sortable: true
				},
				/*{
                    key: 'Contacts_Info::Contact Middle Name',
                    label: 'Contacts_Info::Contact Middle Name',
                    sortable: true
                },*/
				{
					key: 'Contacts_Info::Title',
					label: 'Title',
					sortable: true
				},
				{
					key: 'Contacts_Info::City',
					label: 'City',
					sortable: true
				},
				{
					key: 'Contacts_Info::Contact Direct Telephone Mask',
					label: 'Phone',
					sortable: true
				},
				{
					key: 'Contacts_Info::Contact Direct Telephone Extension',
					label: 'Ext',
					sortable: true
				}
			]
		}
	}
}
</script>

<style scoped>
.detail-field-group div {
    margin-bottom: 0.5em;
}

.detail-field-group label {
    margin-bottom: 0;
    font-weight: bold;
}

#company-container #registration-table >>> td:nth-child(5) {
    text-align: right;
}
</style>